module.exports = __webpack_public_path__ + "media/images/agathe 2-7dea4b79b4d5e79a7ae86223f371b566.jpg";